// src/reducers/csvMappingReducer.tsx

import { STORE_CSV_MAPPING, CLEAR_CSV_MAPPINGS } from "../actions/actionTypes";

interface CsvMappingState {
  storedMappings: Record<string, string>; // crmFieldValue -> csvColumn
  mappingHistory: Array<{
    timestamp: string;
    mappings: Record<string, string>;
    fileName: string;
  }>;
}

const initialState: CsvMappingState = {
  storedMappings: {},
  mappingHistory: []
};

const csvMappingReducer = (
  state: CsvMappingState = initialState,
  action: { type: string; payload: any }
): CsvMappingState => {
  switch (action.type) {
    case STORE_CSV_MAPPING:
      return {
        ...state,
        storedMappings: {
          ...state.storedMappings,
          ...action.payload.mappings
        },
        mappingHistory: [
          ...state.mappingHistory.slice(-9), // Keep last 10 entries
          {
            timestamp: action.payload.timestamp,
            mappings: action.payload.mappings,
            fileName: action.payload.fileName
          }
        ]
      };

    case CLEAR_CSV_MAPPINGS:
      return initialState;

    default:
      return state;
  }
};

export default csvMappingReducer;